module.exports = __webpack_public_path__ + "static/building-a-brotherhood-f8ba5b861bb2989780e66446407d6f65.jpg";